import React from 'react';
import { ServicePageLayout } from '../../components/feature/service-page/ServicePageLayout';

const RealmeServicePage: React.FC = () => {
  return (
    <ServicePageLayout
      seo={{
        title: "Realme Repair Kochi - Realme Service Center Kerala | Device Doctor",
        description: "Professional Realme repair services in Kochi, Kerala. Expert Realme device repair for GT series, C series, Narzo series. Screen replacement, battery repair, charging issues. Fast service with genuine parts.",
        keywords: "realme repair kochi, realme service center kerala, realme screen repair, realme battery replacement, realme repair vyttila, realme charging port repair",
        structuredData: { "@context": "https://schema.org", "@type": "Service", "name": "Realme Repair Services", "brand": { "@type": "Brand", "name": "Realme" } }
      }}
      hero={{
        title: "Realme Service Centre in Kochi",
        subtitle: "Expert Realme mobile repair services with genuine parts, transparent pricing, and same-day service. All-Kerala Courier Services available.",
        stats: [{ value: '400+', label: 'Realme Repairs' }, { value: '4.9★', label: 'Customer Rating' }, { value: 'Same Day', label: 'Service Available' }],
        backgroundImage: "/assets/realme-hero-bg.jpg"
      }}
      serviceList={{
        introParagraph: "Comprehensive repair solutions for all Realme smartphone issues with genuine parts and expert technicians.",
        services: [
          { id: 'display', title: 'Display & Touchscreen Repairs', icon: 'ri-smartphone-line', image: '/assets/android-repair-new.jpg', description: 'Complete screen solutions for your Realme phone.', subServices: [{ title: 'Screen Repairs', description: 'Solutions for cracked glass, flicker, and touch issues.', features: ['Screen replacement', 'Touch calibration', 'Ghost-touch fix', 'Backlight issues'] }] }
        ]
      }}
      features={{
        title: "Why Choose Device Doctor for Realme Repairs",
        subtitle: "Experience the difference with Kerala's most trusted Realme service center.",
        badgeText: "Why Choose Us",
        items: [
          { icon: 'ri-user-star-line', title: 'Certified Realme Technicians', description: 'Our team consists of certified professionals with deep expertise in Realme repairs.' },
          { icon: 'ri-shield-check-line', title: 'Original Realme Parts Only', description: 'We use 100% genuine and brand-approved spare parts to ensure quality.' },
          { icon: 'ri-time-line', title: 'Same-Day Service', description: 'Most repairs are completed within the same day for your convenience.' },
          { icon: 'ri-price-tag-3-line', title: 'Transparent Pricing', description: 'No hidden charges. We provide upfront, honest pricing with free diagnostics.' },
          { icon: 'ri-truck-line', title: 'All-Kerala Delivery Service', description: 'Convenient delivery services across all Kerala.' },
          { icon: 'ri-award-line', title: '1-Month Service Warranty', description: 'All repairs come with a comprehensive 1-month warranty.' }
        ]
      }}
      models={{
        title: "Realme Models We Service",
        subtitle: "We provide expert repair services for all Realme smartphone models.",
        categories: [
          { title: 'C-Series Models', icon: 'ri-smartphone-line', models: ['Realme C11', 'Realme C21', 'Realme C35'], color: 'bg-yellow-500' },
          { title: 'Number Series', icon: 'ri-smartphone-fill', models: ['Realme 8', 'Realme 9 Pro', 'Realme 10 Pro+'], color: 'bg-green-500' }
        ]
      }}
      testimonials={{
        items: [
          { name: 'Akhil R.', location: 'Kochi', rating: 5, text: 'Cracked my Realme 8 screen; Device Doctor replaced it quickly and professionally.', service: 'Screen Replacement' },
          { name: 'Sneha L.', location: 'Thrippunithura', rating: 5, text: 'They fixed my charging issue fast. Great communication and very neat work!', service: 'Charging Port Repair' }
        ]
      }}
      faq={{
        items: [
          { question: 'How long does a Realme repair take?', answer: 'Most display, battery, and charging repairs are completed within the same day.' },
          { question: 'Are the parts genuine?', answer: 'Yes — all components used are 100% original and Realme-certified with 1-month warranty.' }
        ]
      }}
      cta={{
        title: "Ready to Fix Your Realme?",
        subtitle: "Get your Realme phone repaired by Kerala's trusted mobile service experts. Contact Device Doctor – Best Realme Service Centre in Kochi.",
        themeColor: "yellow"
      }}
    />
  );
};

export default RealmeServicePage;
export { RealmeServicePage };